import { render, staticRenderFns } from "./PaymentEfectyBaloto.vue?vue&type=template&id=9308ae2c"
import script from "./PaymentEfectyBaloto.vue?vue&type=script&lang=js"
export * from "./PaymentEfectyBaloto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports